// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  furnitureUid: __t.string().primaryKey().name("furniture_uid"),
  restaurantId: __t.u64().name("restaurant_id"),
  defId: __t.string().name("def_id"),
  plates: __t.u32(),
  glasses: __t.u32(),
  cycleTimeRemainingMs: __t.i64().name("cycle_time_remaining_ms"),
  platesTiers: __t.option(__t.string()).name("plates_tiers"),
  glassesTiers: __t.option(__t.string()).name("glasses_tiers"),
});
